var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconGermanFlag = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.903 4.82617H2.09699C0.93882 4.82617 0 5.76499 0 6.92316V10.9411H28V6.92316C28 5.76499 27.0612 4.82617 25.903 4.82617Z",
    fill: "#464655"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.0765C0 22.2347 0.93882 23.1735 2.09699 23.1735H25.903C27.0611 23.1735 28 22.2347 28 21.0765V17.0586H0V21.0765Z",
    fill: "#FFE15A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 10.9414H0V17.056H28V10.9414Z",
    fill: "#FF4B55"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconGermanFlag, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-german-flag.fd50cb90.svg";
export { ForwardRef as ReactComponent };